<template>
  <div :class="final ? 'move-panel' : ''">
    <b-card-title>{{ $t("label.detalles.demanda") }}</b-card-title>
    <div v-if="cliente && delegacion && divisa">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">1</b-button>
        </b-col>
        <b-col lg="11" md="11" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col lg="6" md="6">
                  <label class="recent-label" for="desCliente">{{ $t("label.cliente") }}</label>
                  <span id="desCliente">{{ cliente.desCliente }}</span>
                </b-col>
                <hr />
                <b-col lg="4" md="4">
                  <label class="recent-label" for="desDelegacion">{{
                    $t("label.delegacion")
                  }}</label>
                  <span id="desDelegacion">{{ delegacion.desDelegacion }}</span>
                </b-col>
                <hr />
                <b-col v-if="transportadora" lg="7" md="7">
                  <label class="recent-label" for="transportadora">{{
                    $t("label.transportadora")
                  }}</label>
                  <span id="transportadora">{{ transportadora.descripcion }}</span>
                </b-col>
                <b-col lg="2" md="2">
                  <label class="recent-label" for="divisa">{{ $t("label.divisa") }}</label>
                  <span id="divisa">{{ divisa.simbolo }} {{ divisa.codDivisa }}</span>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-if="calidadesDenominacion.length > 0">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">2</b-button>
        </b-col>
        <b-col lg="11" md="11" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col>
                  <span class="recent-label">{{ $t("label.total.demandar") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold">
                    {{ divisa.simbolo }} {{ filterNumber(saldoDemandar, 2) }}
                  </span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-card-title>{{ $t("label.demandas") }}</b-card-title>
              <div
                v-for="calidadDenominacion in calidadesDenominacion"
                :key="calidadDenominacion.id"
              >
                <b-row>
                  <b-col>
                    <span class="recent-label">{{ $t("label.denominacion") }}</span>
                  </b-col>
                  <b-col>
                    <span class="recent-label">{{ $t("label.demanda") }}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <span>
                      {{ calidadDenominacion.denominacion.codDenominacion }}
                      {{ calidadDenominacion.desCalidad }}
                    </span>
                  </b-col>
                  <b-col cols="6">
                    <span v-if="calidadDenominacion.importe">
                      {{ divisa.simbolo }} {{ filterNumber(calidadDenominacion.importe, 2) }}
                    </span>
                    <span v-else>{{ divisa.simbolo }} 0</span>
                  </b-col>
                </b-row>
              </div>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div v-if="fechaExpiracion && horaExpiracion && coste">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">3</b-button>
        </b-col>
        <b-col lg="11" md="11" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col>
                  <span class="recent-label">{{ $t("label.fecha.expiracion") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold">{{
                    filterDate(fechaExpiracion)
                  }}</span>
                </b-col>
                <b-col>
                  <span class="recent-label">{{ $t("label.hora.expiracion") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold">{{ horaExpiracion }}</span>
                </b-col>
                <b-col>
                  <span class="recent-label">{{ $t("label.coste") }}</span>
                  <br />
                  <span class="recent-label font-weight-bold">{{ coste.codParametro }}</span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-row>
                <b-col v-if="cliente.pais.admiteAnonimo">
                  <span class="recent-label">{{ $t("label.anonimo") }}</span>
                  <br />
                  <span v-if="anonimo">{{ $t("label.si") }}</span>
                  <span v-else>{{ $t("label.no") }}</span>
                </b-col>
                <b-col>
                  <span class="recent-label">{{ $t("label.parcial") }}</span>
                  <br />
                  <span v-if="parcial">{{ $t("label.si") }}</span>
                  <span v-else>{{ $t("label.no") }}</span>
                </b-col>
                <b-col v-if="cliente.pais.hasTasa">
                  <span class="recent-label">{{ $t("label.tasa") }}</span>
                  <br />
                  <span>{{ filterNumber(tasa, 5) }} %</span>
                </b-col>
              </b-row>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div v-if="demandaPaso4Params.relleno">
      <b-row>
        <b-col cols="1" class="mt-5">
          <b-button disabled pill variant="primary" class="btn-number font-weight-bold">4</b-button>
        </b-col>
        <b-col lg="11" Smd="11" class="mt-2">
          <b-card>
            <b-card-body v-if="isShowBankField">
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="cuentaCorriente">
                    {{ $t("label.cuentaCorriente") }}
                  </label>
                  <span id="cuentaCorriente">{{ demandaPaso4Params.cuentaCorriente }}</span>
                </b-col>
                <hr />
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="agNumeroSucursal">
                    {{ $t("label.agNumeroSucursal") }}
                  </label>
                  <span id="agNumeroSucursal">{{ demandaPaso4Params.agNumeroSucursal }}</span>
                </b-col>
                <hr />
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="ispbBanco">{{ $t("label.ispbBanco") }}</label>
                  <span id="ispbBanco">{{ demandaPaso4Params.ispbBanco }}</span>
                </b-col>
                <b-col md="12" lg="12" xl="6">
                  <label class="recent-label" for="cnpjPersona">
                    {{ $t("label.cnpjPersona") }}
                  </label>
                  <span id="cnpjPersona">{{ demandaPaso4Params.cnpjPersona }}</span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col lg="12" md="12">
                  <label class="recent-label" for="observacionesDemanda">
                    {{ $t("label.observaciones") }}
                  </label>
                  <span id="observacionesDemanda">
                    {{ demandaPaso4Params.observacionesDemanda }}
                  </span>
                </b-col>
              </b-row>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ICalidadDenominacion,
  ICliente,
  IDelegacion,
  IDivisa,
  IParametro,
  ITransportadora,
} from "@/entities";
import { IDemandaPaso4Params } from "@/services";
import VueFilters from "@/vue-filters";

@Component({
  name: "resumen-demanda",
  mixins: [VueFilters],
})
export default class ResumenDemanda extends Vue {
  @Prop({ required: false, default: null }) cliente!: ICliente;
  @Prop({ required: false, default: null }) delegacion!: IDelegacion;
  @Prop({ required: false, default: null }) transportadora!: ITransportadora;
  @Prop({ required: false, default: null }) divisa!: IDivisa;
  @Prop({ required: false, default: null }) calidadesDenominacion!: ICalidadDenominacion[];
  @Prop({ required: false, default: null }) saldoDemandar!: number;
  @Prop({ required: false, default: null }) fechaExpiracion!: string;
  @Prop({ required: false, default: null }) horaExpiracion!: string;
  @Prop({ required: false, default: null }) coste!: IParametro;
  @Prop({ required: false, default: null }) anonimo!: boolean;
  @Prop({ required: false, default: null }) parcial!: boolean;
  @Prop({ required: false, default: null }) tasa!: number;
  @Prop({ required: false, default: null }) demandaPaso4Params!: IDemandaPaso4Params;
  @Prop({ required: false, default: null }) final!: boolean;
  isShowBankField = false;

  constructor() {
    super();
  }

  mounted(): void {
    this.isShowBankField = this.cliente?.pais.hasInfoBancaria || false;
  }
}
</script>

<style lang="scss" scoped>
.recent-label {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 30px;
  letter-spacing: normal;
  color: var(--secundario-prosegur-claro);
}

.btn-number {
  border-color: transparent;
  background-color: rgba(0, 0, 0, 0.03);
}

.card {
  margin: 0 0 0 0.75rem;
}

.card span {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}

.card span:hover {
  white-space: normal;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

.move-panel {
  transition: all 1.5s ease-in-out;
  transform: translate(-25vw, 0);
}
</style>
